import { observer } from 'mobx-react';
import React, { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from 'components/Breadcrumbs';

import RefreshData from '../RefreshData';
import StudentPickerModal from '../StudentPickerModal';
import HeaderToolBar from './ToolBar';
import { AppBar, AppBox } from './styled';

interface ILayoutProps {
	children?: ReactNode;
}

function Layout({ children }: ILayoutProps) {
	const { i18n } = useTranslation();

	return (
		<>
			<StudentPickerModal />
			<AppBox>
				<AppBar position="sticky" top={0} zIndex={10}>
					<HeaderToolBar />
				</AppBar>
				<Breadcrumbs />
				<Fragment key={i18n.language}>{children}</Fragment>
			</AppBox>
			<RefreshData />
		</>
	);
}

export default observer(Layout);
